<template>
  <v-container fluid fill-height class="error-page">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" class="text-center">
        <v-icon :color="errorConfig.color" size="96">{{
          errorConfig.icon
        }}</v-icon>
        <div
          :class="['error-code mt-4', `${errorConfig.color}--text`]"
        >
          {{ errorCode }}
        </div>

        <div class="error-title mt-2">
          {{ errorConfig.title }}
        </div>

        <div class="error-description mt-3 grey--text text--darken-1">
          {{ errorConfig.description }}
        </div>

        <div class="mt-8 d-flex justify-center" style="gap: 12px">
          <v-btn
            v-if="isShowGoToDashboard"
            outlined
            color="primary"
            @click="goToDashboard"
          >
            กลับหน้าหลัก
          </v-btn>
          <v-btn text color="grey darken-1" @click="logout">
            ออกจากระบบ
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const ERROR_CONFIGS = {
  401: {
    color: 'orange',
    title: 'ไม่ได้รับอนุญาต',
    description:
      'เซสชันของคุณหมดอายุหรือยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบอีกครั้ง',
  },
  403: {
    color: 'orange',
    title: 'ไม่มีสิทธิ์เข้าถึง',
    description:
      'คุณไม่มีสิทธิ์ในการเข้าถึงหน้านี้ หากต้องการความช่วยเหลือ กรุณาติดต่อผู้ดูแลระบบ',
  },
  404: {
    color: 'blue-grey',
    title: 'ไม่พบหน้าที่ต้องการ',
    description: 'หน้าที่คุณกำลังค้นหาไม่มีอยู่หรืออาจถูกลบไปแล้ว',
  },
  500: {
    color: 'red',
    title: 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์',
    description:
      'เกิดข้อผิดพลาดบางอย่างจากทางเรา กรุณาลองใหม่อีกครั้งในภายหลัง',
  },
}

const DEFAULT_CONFIG = {
  color: 'grey',
  title: 'เกิดข้อผิดพลาด',
  description:
    'เกิดข้อผิดพลาดที่ไม่คาดคิด กรุณาลองใหม่อีกครั้งหรือติดต่อทีมสนับสนุน',
}

export default {
  name: 'ErrorPage',
  computed: {
    errorCode() {
      return this.$route.params.code || ''
    },
    errorConfig() {
      return ERROR_CONFIGS[this.errorCode] || DEFAULT_CONFIG
    },
    isShowGoToDashboard() {
      return this.errorCode != '401' && this.errorCode != '403'
    },
  },
  methods: {
    goToDashboard() {
      this.$router.push({ name: 'Dashboard' })
    },
    logout() {
      this.$store.dispatch('auth/logout')
    },
  },
}
</script>

<style scoped>
.error-page {
  min-width: 100vw;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.error-code {
  font-size: 72px;
  font-weight: 700;
  line-height: 1;
}

.error-title {
  font-size: 24px;
  font-weight: 600;
  color: #212121;
}

.error-description {
  font-size: 15px;
  line-height: 1.6;
}
</style>
